module.exports = __webpack_public_path__ + "components/nearby/static/nearby-location--white-50b80b7d4d777e588d88fc4f7624bc5e.svg";